import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { dayjsInit, getDateObject } from '@ow/utils'
import { Select } from '@mantine/core'
import { useClickOutside } from '@mantine/hooks'
import {
  StyledWrapper,
  StyledCalendar,
  StyledSelect,
  StyledCalendarWrapper,
} from './styled'
import Input from '../input/input-base'
import RenderIf from '../render-if'

// 日期格式化
const formatDate = (time) => {
  return dayjsInit(time).format('YYYY/MM/DD')
}
const completFn = (s) => {
  return s < 10 ? '0' + s : s
}

const hoursArr = []
for (let i = 0; i <= 24; i++) {
  hoursArr.push({ value: String(i), label: completFn(i) })
}
const minuteArr = []
for (let i = 0; i <= 59; i++) {
  minuteArr.push({ value: String(i), label: completFn(i) })
}
// const yearArr = []
// for (let i = 1977; i <= 2032; i++) {
//   yearArr.push({ value: i, label: i })
// }
const monthArr = []
for (let i = 1; i < 13; i++) {
  monthArr.push({ value: i, label: `${i}月` })
}
const DatePicker = (props) => {
  const {
    style,
    className,
    // style 样式需要区分一下
    inputStyle,
    calendarStyle,
    // danhua加的
    currentDate,
    selectedDate,
    minDate,
    maxDate,
    locale,
    disabledDates,
    disabledDay,
    showMonthArrow,
    showMonthAndYearPickers,
    navigatorRenderer,
    editableDateInputs,
    dragSelectionEnabled,
    placeholder,
    currentDateColor,
    currentDateBackground,
    selectedDateColor,
    selectedDateBackground,
    dateDisplayFormat,
    dayDisplayFormat,
    dayContentRenderer,
    onChange,
    showTime,
    showMonth,
    monthType,
    selectWidth,
    selectStyles,
    disabled,
  } = props
  const [show, setShow] = useState(false)
  const [date, setDate] = useState(selectedDate)
  const [curHour, setCurHour] = useState('')
  const [curMinute, setCurMinute] = useState('')
  const [curMonth, setCurMonth] = useState()
  const inputRef = useRef()
  const [calStyle, setCalStyle] = useState({})
  const datePickerRef = useClickOutside(() => setShow(false))
  useEffect(() => {
    setDate(selectedDate)
    if (!selectedDate) {
      setCurHour('')
      setCurMinute('')
      setCurMonth(null)
    } else {
      const dateObj = getDateObject(selectedDate)
      const { month = '', hour = '', minute = '' } = dateObj
      setCurHour(String(hour))
      setCurMinute(String(minute))
      setCurMonth(String(month))
    }
  }, [selectedDate])
  const currentDateStr = () => {
    if (!date) return ''
    return formatDate(new Date(date), 'yyyy/MM/dd')
  }
  const onChangeDate = (time) => {
    setDate(time)
    if (onChange) {
      onChange(
        new Date(`${formatDate(time)} ${curHour || '00'}:${curMinute || '00'}`)
      )
    }
    setShow(false)
  }
  const initDateStyle = () => {
    if (!inputRef.current) return
    const inputStyles = inputRef.current.getBoundingClientRect()
    const { left = 0 } = inputStyles
    if (left + 345 < window.innerWidth) return
    setCalStyle({
      left: 'auto',
      right: '0',
    })
  }
  useEffect(() => {
    if (typeof document !== 'object') {
      return
    }
    // 控制位置，防止日期选择溢出屏幕
    initDateStyle()
  }, [])
  const resetDate = () => {
    if (!date) return
    onChange()
    setDate(undefined)
  }
  // 自定义无效时间
  const customDisabledDay = (displayDate) => {
    if (minDate && maxDate) {
      return displayDate < minDate || displayDate > maxDate
    }
    if (minDate && !maxDate) {
      return displayDate < minDate
    }
    if (!minDate && maxDate) {
      return displayDate > maxDate
    }
    return false
  }
  useEffect(() => {
    if (!show) return
    initDateStyle()
  }, [show])

  return (
    <StyledWrapper style={style}>
      <div className="flex">
        {showMonth && (
          <div style={{ width: selectWidth }} className="flex-1">
            <Select
              className="ml-2 z-50"
              isSearchable={false}
              data={monthArr}
              styles={selectStyles}
              placeholder={placeholder || '月'}
              value={
                monthType === 'picker' && date
                  ? dayjsInit(date).month() + 1
                  : curMonth
              }
              onChange={(e) => {
                setCurMonth(e)
                let value = ''
                if (e < 10) {
                  value = `0${e}`
                } else {
                  value = e
                }

                const endOfMonth = dayjsInit(`${dayjsInit().year()}-${value}`)
                  .endOf('month')
                  .format('YYYY-MM-DD')

                if (onChange) {
                  if (monthType === 'range') {
                    onChange({
                      startDate: new Date(
                        `${dayjsInit().year()}-${value}-01 00:00:00`
                      ),
                      endDate: new Date(`${endOfMonth} 23:59:59`),
                    })
                  }
                  if (monthType === 'picker') {
                    onChange(new Date(`${dayjsInit().year()}-${value}-01`))
                  }
                }
              }}
            />
          </div>
        )}
        {!showMonth && (
          <div className="Calendar flex-1" style={{ height: '100%' }}>
            <Input
              style={
                showTime ? { ...inputStyle, width: '100%' } : inputStyle || {}
              }
              disabled={disabled}
              placeholder={placeholder}
              value={currentDateStr()}
              onFocus={() => setShow(true)}
              onChange={resetDate}
              ref={inputRef}
            />
            {show && (
              <StyledCalendarWrapper style={calStyle} ref={datePickerRef}>
                <StyledCalendar
                  style={calendarStyle}
                  className={className}
                  date={date}
                  locale={locale}
                  shownDate={currentDate}
                  showMonthAndYearPickers={showMonthAndYearPickers}
                  minDate={minDate}
                  maxDate={maxDate}
                  disabledDates={disabledDates}
                  disabledDay={disabledDay || customDisabledDay}
                  showMonthArrow={showMonthArrow}
                  navigatorRenderer={navigatorRenderer}
                  editableDateInputs={editableDateInputs}
                  dragSelectionEnabled={dragSelectionEnabled}
                  placeholder={placeholder}
                  currentDateColor={currentDateColor}
                  currentDateBackground={currentDateBackground}
                  selectedDateColor={selectedDateColor}
                  selectedDateBackground={selectedDateBackground}
                  onChange={onChangeDate}
                  dateDisplayFormat={dateDisplayFormat}
                  dayDisplayFormat={dayDisplayFormat}
                  dayContentRenderer={dayContentRenderer}
                />
              </StyledCalendarWrapper>
            )}
          </div>
        )}
        <RenderIf isTrue={showTime}>
          <StyledSelect>
            <Select
              style={{
                margin: '0 10px',
              }}
              placeholder="时"
              data={hoursArr}
              disabled={!date}
              value={curHour || ''}
              onChange={(e) => {
                setCurHour(e)
                if (onChange) {
                  onChange(
                    new Date(`${formatDate(date)} ${e}:${curMinute || '00'}`)
                  )
                }
              }}
            />
            <Select
              data={minuteArr}
              disabled={!date}
              placeholder="分"
              value={curMinute || ''}
              onChange={(e) => {
                setCurMinute(e)
                if (onChange) {
                  onChange(
                    new Date(`${formatDate(date)} ${curHour || '00'}:${e}`)
                  )
                }
              }}
            />
          </StyledSelect>
        </RenderIf>
      </div>
    </StyledWrapper>
  )
}

// 参数类型
DatePicker.propTypes = {
  className: PropTypes.string,
  selectWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  selectStyles: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  showMonthAndYearPickers: PropTypes.bool,
  currentDate: PropTypes.shape({}),
  minDate: PropTypes.shape({}),
  maxDate: PropTypes.shape({}),
  disabledDates: PropTypes.bool,
  disabledDay: PropTypes.bool,
  showMonthArrow: PropTypes.bool,
  navigatorRenderer: PropTypes.func,
  editableDateInputs: PropTypes.bool,
  dragSelectionEnabled: PropTypes.bool,
  placeholder: PropTypes.string,
  currentDateColor: PropTypes.string,
  currentDateBackground: PropTypes.string,
  selectedDateColor: PropTypes.string,
  selectedDateBackground: PropTypes.string,
  onChange: PropTypes.func,
  dateDisplayFormat: PropTypes.string,
  dayDisplayFormat: PropTypes.string,
  dayContentRenderer: PropTypes.func,
}
DatePicker.defaultProps = {
  className: undefined,
  selectStyles: undefined,
  selectWidth: undefined,
  showMonthAndYearPickers: undefined,
  currentDate: undefined,
  minDate: undefined,
  maxDate: undefined,
  disabledDates: undefined,
  disabledDay: undefined,
  showMonthArrow: undefined,
  navigatorRenderer: undefined,
  editableDateInputs: undefined,
  dragSelectionEnabled: undefined,
  placeholder: undefined,
  currentDateColor: undefined,
  currentDateBackground: undefined,
  selectedDateColor: undefined,
  selectedDateBackground: undefined,
  onChange: () => {},
  dateDisplayFormat: undefined,
  dayDisplayFormat: undefined,
  dayContentRenderer: undefined,
}
export default DatePicker
